import { FILE_ACTIONS } from 'UI/components/molecules/FileItem/FileItem.constants';
import { getfileExplorerSectionByCategory } from 'UI/components/organisms/sendouts/utils';

export const getResolvedCategories = ({
  categories,
  categoryIdMap,
  fileExplorerSections,
  groupedFiles
}) =>
  categories.map(category => {
    const mappedCategoryId = categoryIdMap?.[category.id] ?? category.id;

    return {
      category,
      mappedCategory: { ...category, id: mappedCategoryId },
      mappedCategoryId,
      filesByCategory: groupedFiles[mappedCategoryId] || [],
      filteredSections: fileExplorerSections?.length
        ? getfileExplorerSectionByCategory(fileExplorerSections, mappedCategoryId)
        : []
    };
  });

export const getAllowedActions = ({ allowDelete, file, isReadonlyVariant = false }) => {
  const actions = [FILE_ACTIONS.Download, FILE_ACTIONS.View];

  if (!isReadonlyVariant && allowDelete && file?.type === 'new') {
    actions.push(FILE_ACTIONS.Delete);
  }

  return actions;
};
